export default __webpack_public_path__ + "static/media/4.1.138b9ad2.webm";